import React, { useEffect } from 'react';
import { useTotem } from '../../../hooks/useCases/useTotem';
import { SolicitudesRecepcionista } from './Menu/SolicitudesRecepcionista';
import { AreasRecepcionista } from './Menu/AreasRecepcionista';
import { CargaAfiliado } from './Menu/CargaAfiliado';
import { Grid } from '@material-ui/core';
import { TotemBreadcrumb } from './Breadcrumb/TotemBreadcrumb';
import { MENU_TOTEM } from '../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveBreadcrumbTotem } from '../../../actions/totem/totemActions';

const style = {
  root: {
    flexGrow: 1,
  },
};

export const TotemRecepcionistasHome = (props) => {
  const totem = useTotem();
  const  dispatch = useDispatch();
  const { activeBreadcrumb } = useSelector((state) => state.totem);

  const resetRouteStateAndSetActiveBreacDrumb = (item) => {
    props.location.state = { from: props.location.pathname };
    dispatch(setActiveBreadcrumbTotem(item));
  };

  useEffect(() => {
    dispatch(setActiveBreadcrumbTotem(MENU_TOTEM.DESELECCIONAR));
  }, [dispatch]);

  useEffect(() => {
    dispatch(setActiveBreadcrumbTotem(MENU_TOTEM.DESELECCIONAR));
  }, [dispatch]);

  useEffect(() => {
    totem.get.opciones();
    totem.get.recepciones();
    totem.get.recepcionesUsuarios();
    totem.getById.solicitudesRecepcionesUsuario();
  }, []);
 
  return (
    <div className={style.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <TotemBreadcrumb
            activeBreadcrumb={activeBreadcrumb}
            setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
          />
        </Grid>
        {activeBreadcrumb === MENU_TOTEM.SOLICITUDES_RECEPCIONISTA && (
          <SolicitudesRecepcionista />
        )}
        {activeBreadcrumb === MENU_TOTEM.GESTION_AREAS_RECEPCIONISTA && totem.data.recepcionesUsuario.length > 0 && <AreasRecepcionista />}
        {activeBreadcrumb === MENU_TOTEM.CARGA_SOLICITUD_AFILIADO && totem.data.recepcionesUsuario.length > 0 && <CargaAfiliado />}
      </Grid>
    </div>
    // <GenericBreadcrumb 
    //   breads={[
    //     {
    //       text: "Solicitudes Recepcionista",
    //       Icon: <Assignment />,
    //       Component: <SolicitudesRecepcionista />
    //     },
    //     ...(totem.data.recepcionesUsuario.length > 0
    //       ? 
    //       [
    //           {
    //             text: "Gestion Areas Recepcionista",
    //             Icon: <Place />,
    //             Component: <AreasRecepcionista />,
    //           },
    //           {
    //             text: "Carga Solicitud Afiliado",
    //             Icon: <Person />,
    //             Component: <CargaAfiliado />,
    //             onClick: () => { totem.clean.afiliados(); }
    //           }
    //         ]
    //       : []
    //     )
    //   ]}
    // />
  )
}